import React from "react";

const StatusProgressBar = ({ status }) => {
  // Define the ordered progress bar statuses
  const statuses = [
    "Pending Diligent Review",
    "Accepted",
    "Auditor Assigned",
    "Assessment Scheduled",
    "Assessment in Progress",
    "First Draft",
    "Final Report",
  ];

  // Define the mapping of statuses based on dropdown conditions
  const statusConditions = {
    "No status selected": "Pending Diligent Review",
    Denied: -1,
    "Pending Diligent Review": "Pending Diligent Review",
    "Request Accepted": "Accepted",
    "Intro Email Sent": "Accepted",
    "Intro Meeting Complete": "Accepted",
    "Planning Meeting Complete": "Accepted",
    Accepted: "Accepted",
    "Auditor Assigned": "Auditor Assigned",
    "Assessment Scheduled": "Assessment Scheduled",
    "Assessment in Progress": "Assessment in Progress",
    "Assessment Complete": "Assessment in Progress", // Maps to the closest
    "Draft Review by Sponsor": "First Draft",
    "Draft Review by Client": "First Draft",
    "First Draft": "First Draft",
    "Draft Report Delivered": "First Draft",
    "Final Report Delivered": "Final Report",
    "Report Anonymized": "Final Report",
    "Report Published to Library": "Final Report",
    VQA: "Final Report",
  };
  // Find the closest progress bar status for the given status
  const closestStatus = statusConditions[status];

  // Find the index in the ordered status list
  const currentIndex = statuses.indexOf(closestStatus);

  // Calculate progress percentage
  const progressPercentage =
    currentIndex !== -1 ? ((currentIndex + 1) / statuses.length) * 100 : 0;

  return (
    <div className="w-full">
      {/* Progress bar container */}
      <div className="relative h-2 rounded-lg bg-gray-200">
        {/* Filled progress */}
        <div
          className="absolute top-0 left-0 h-full rounded-lg bg-indigo-600 transition-width duration-300"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>

      {/* Status labels */}
      <div className="hidden custom-breakpoint-10:flex custom-breakpoint-10:justify-between mt-2 text-sm font-medium text-gray-700">
        {statuses.map((s, index) => (
          <div
            key={index}
            className={`text-center break-words whitespace-normal max-w-[140px] text-ellipsis overflow-hidden
        ${index <= currentIndex ? "text-indigo-600" : "text-gray-600 "} 
        text-[15px] font-semibold mt-5`}
          >
            {s}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatusProgressBar;
